export default __webpack_public_path__ + "static/media/notification-envelope-icon.3b3c95fc.svg";